import { useRef, useEffect, useState } from "react";
import { Table, TableProps } from "antd";

function TopScrollTable<T extends object>(props: TableProps<T>) {
  const topRef = useRef<HTMLDivElement>(null);
  const bottomRef = useRef<HTMLDivElement>(null);
  const [innerWidth, setInnerWidth] = useState(0);

  useEffect(() => {
    const wrapper = bottomRef.current;
    if (!wrapper) return;

    const updateWidth = () => {
      const content = wrapper.querySelector<HTMLElement>(".ant-table-content");
      const table = content?.querySelector("table");
      setInnerWidth(table?.scrollWidth ?? 0);
    };

    updateWidth();

    // Observe the inner <table> element which grows when columns are wide
    const content = wrapper.querySelector<HTMLElement>(".ant-table-content");
    const tableEl = content?.querySelector("table");
    const observer = new ResizeObserver(updateWidth);
    if (tableEl) observer.observe(tableEl);

    return () => observer.disconnect();
  }, [props.dataSource]);

  useEffect(() => {
    const top = topRef.current;
    const wrapper = bottomRef.current;
    if (!top || !wrapper) return;
    const content = wrapper.querySelector<HTMLElement>(".ant-table-content");
    if (!content) return;
    const syncFromTop = () => {
      content.scrollLeft = top.scrollLeft;
    };
    const syncFromBottom = () => {
      top.scrollLeft = content.scrollLeft;
    };
    top.addEventListener("scroll", syncFromTop);
    content.addEventListener("scroll", syncFromBottom);
    return () => {
      top.removeEventListener("scroll", syncFromTop);
      content.removeEventListener("scroll", syncFromBottom);
    };
  }, []);

  return (
    <>
      <div ref={topRef} className="top-scroll-bar">
        <div style={{ width: innerWidth, height: 1 }} />
      </div>
      <div ref={bottomRef} className="top-scroll-table-wrapper">
        <Table<T> {...props} />
      </div>
    </>
  );
}

export default TopScrollTable;
